// useResizeObserver — extrahiert aus app/src/utils/useResizeObserver.ts
// (Plan A Mapping-Audit 2026-05-22). Pure utility, kein app/-Coupling.

import type { RefObject } from "react";
import { useEffect } from "react";

export default function useResizeObserver(
  ref: RefObject<HTMLElement | null>,
  onResize: (e: HTMLElement) => void,
) {
  const element = ref.current;
  useEffect(() => {
    if (element) {
      const resizeObserver = new ResizeObserver(() => {
        onResize(element);
      });
      resizeObserver.observe(element);
      return () => {
        resizeObserver.disconnect();
      };
    }
  }, [element, onResize, ref]);
}
